import { render, staticRenderFns } from "./DeleteUniverseModal.vue?vue&type=template&id=13a1aa06"
import script from "./DeleteUniverseModal.vue?vue&type=script&lang=js"
export * from "./DeleteUniverseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a1aa06')) {
      api.createRecord('13a1aa06', component.options)
    } else {
      api.reload('13a1aa06', component.options)
    }
    module.hot.accept("./DeleteUniverseModal.vue?vue&type=template&id=13a1aa06", function () {
      api.rerender('13a1aa06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeleteUniverseModal.vue"
export default component.exports